import { configureStore } from '@reduxjs/toolkit'

import MorningScanReducer from './MorningScan'
import { api } from './services/api'

export const store = configureStore({
  reducer: {
    morningScan: MorningScanReducer,
    [api.reducerPath]: api.reducer,
  },
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
